<template>
  <div class="ui modal">
    <i class="close icon"></i>
    <div class="header">
      Profile Picture
    </div>
    <div class="image content">
      <div class="ui medium image">
        <img src="https://semantic-ui.com/images/avatar2/large/rachel.png">
      </div>
      <div class="description">
        <div class="ui header">We've auto-chosen a profile image for you.</div>
        <p>We've grabbed the following image from the <a href="https://www.gravatar.com" target="_blank">gravatar</a> image associated with your registered e-mail address.</p>
        <p>Is it okay to use this photo?</p>
      </div>
    </div>
    <div class="actions">
      <div class="ui black deny button">
        Nope
      </div>
      <div class="ui positive right labeled icon button">
        Yep, that's me
        <i class="checkmark icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'sing-in',
    data() {
      return {

      }
    },
    mounted() {
      this.$root.$firebaseRefs.anObject.once('value', function(snapshot) {
        window.console.log(snapshot.val())
      })
    }
  }
</script>



// WEBPACK FOOTER //
// SignIn.vue?746750dc